// extracted by mini-css-extract-plugin
export default {"input":"styles_input__CwEBO","input__main":"styles_input__main__sKYed","error":"styles_error__HMnwu","borderError":"styles_borderError__mjLhL"};